

















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import labelOperation from '@/components/label/labelOperation.vue';
import CommentList from '@/components/comment/commentList.vue';
import ReminderOperation from '@/components/reminder/reminderOperation.vue';
import MarkedText from '@/components/marked/markedText.vue';
import { createLabelUrl } from '@/components/label/labelOperation';
import { createCommentUrl } from '@/components/comment/commentOperation';
import { createReminderUrl } from '@/components/reminder/reminderOperation';
import DetailBox from '@/components/detailBox/detailBox.vue';

type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;
type IIssueInfo = IIssue.IResponse.IIssueInfo;
type IUserInfo = IUser.IResponse.IUserDetailInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;


@Component({
  components: {
    labelOperation,
    CommentList,
    ReminderOperation,
    MarkedText,
    DetailBox,
  },
})
export default class IssueDetail extends Vue {
  @Prop({ required: true }) private issue!: IIssueInfo;
  @Prop({ default: false }) private spinning!: boolean;
  get issueId(): string {
    if (this.issue) {
      return this.issue.id;
    } else {
      return '';
    }
  }
  get labelUrl() {
    return createLabelUrl('Issue', this.issueId);
  }
  get commentUrl() {
    return createCommentUrl('Issue', this.issueId);
  }
  get reminderlUrl() {
    return createReminderUrl('Issue', this.issue.id);
  }
  @Watch('issueId')
  private watchIssueId(newIssueId: string) {
    if (newIssueId) {
      this.$emit('refreshDetail', this.issue);
    }
  }
  private requestIssueDetail() {
    this.$emit('refreshDetail', this.issue);
  }
  private editIssue() {
    this.$emit('edit', this.issue);
  }
  private editStatus(status: IIssue.IIssueStatus) {
    this.$emit('statusChange', {
      issue: this.issue,
      status,
    });
  }
  private handleDelIssue() {
    this.$emit('delete', this.issue.id);
  }
  private handleLabelChange(newLabels: ILabelInfo[]) {
    this.$emit('labelChange', { issue: this.issue, labels: newLabels });
  }
  private handleCommentAdd(newComment: ICreateOrUpdateComment) {
    this.$emit('commentChange', {
      issue: this.issue,
      comment: newComment,
      type: 'ADD',
    });
  }
  private handleReminderChange(reminders: IUserInfo[]) {
    this.$emit('reminderChange', {
      issue: this.issue,
      reminders,
    });
  }
}
